/**
 * PlayShop — Align variants area heights by row in collection grids.
 *
 * Scanne les <li.ps-cl__item> du grid : pour chaque RANGÉE (cards
 * partageant le même offsetTop), si AU MOINS UNE card est multi-variant
 * (a `.ps-card__variants`), ajoute la class `row-has-multi` sur TOUTES
 * les cards de la rangée.
 *
 * CSS associé (tokens-v2.css) : `.ps-cl__item.row-has-multi .ps-card__form`
 * → `min-height: 110px; align-items: flex-start` pour aligner le bouton
 * single avec la 1ère ligne du multi voisin.
 *
 * Rangées full-single → pas de class → height naturelle (pas d'espace
 * fictif sous le bouton).
 */
(function () {
  let alignTimer;
  function alignRowsDebounced() {
    clearTimeout(alignTimer);
    alignTimer = setTimeout(alignRows, 100);
  }
  function alignRows() {
    const items = document.querySelectorAll('.ps-cl__item');
    if (!items.length) return;
    const rows = new Map();
    items.forEach((item) => {
      // Skip hidden items (filtered out via display:none or hidden attr)
      if (item.hidden) return;
      const style = window.getComputedStyle(item);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      const top = Math.round(item.offsetTop);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(item);
    });
    rows.forEach((rowItems) => {
      // Default CSS = 1 row (court). On AJOUTE .row-needs-two-rows UNIQUEMENT si la rangée
      // contient une carte avec >=3 variants (typiquement 4 = N+R+P+M).
      // Inversion 2026-05-22 : avant on retirait class pour le cas court → cards rétrécissaient
      // au load (visible). Maintenant : default court → cards s'agrandissent quand mixte.
      const needsTwoRows = rowItems.some((it) => it.querySelectorAll('.ps-card__variant-form').length >= 3);
      rowItems.forEach((it) => {
        it.classList.toggle('row-needs-two-rows', needsTwoRows);
        // Cleanup ancienne class (au cas où en cache)
        it.classList.remove('row-all-single');
      });
    });
  }

  // Initial run : au DOMContentLoaded + load (load = après que tous les images soient chargés,
  // important car offsetTop dépend de la hauteur des images dans le grid)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignRowsDebounced);
  } else {
    alignRowsDebounced();
  }
  window.addEventListener('load', alignRowsDebounced);

  // Resize : reflow possible
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(alignRows, 150);
  });

  // MutationObserver : re-run quand de nouveaux .ps-cl__item sont ajoutés au DOM
  // (pagination infinie, filtres, etc.)
  const grid = document.querySelector('.ps-cl__grid');
  if (grid) {
    const observer = new MutationObserver((mutations) => {
      const hasNewItems = mutations.some((m) =>
        Array.from(m.addedNodes).some(
          (n) => n.nodeType === 1 && (n.classList?.contains('ps-cl__item') || n.querySelector?.('.ps-cl__item'))
        )
      );
      if (hasNewItems) alignRowsDebounced();
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  // Events custom (au cas où d'autres scripts émettent ces events)
  document.addEventListener('ps-collection-items-added', alignRowsDebounced);
  document.addEventListener('ps-collection-filter-applied', alignRowsDebounced);

  // Re-run after image loads (offsetTop change quand images chargent)
  document.querySelectorAll('.ps-cl__item img').forEach((img) => {
    if (!img.complete) img.addEventListener('load', alignRowsDebounced, { once: true });
  });
})();
